import React from 'react';
import styled from "styled-components";
import {FilterDispatcherContext} from "@providers/filters";
import CheckboxListGroup, {CheckboxGroupBox, CheckboxGroupLabel, CheckboxInput} from "@atoms/checkbox.list.group";
import RadiusGenerate from "@helpers/radius.generate";
import ConvertPixelToRem from "@helpers/convert.rem";
import Switch from "@atoms/switch";
import Icon from "@atoms/icon";
import CloseIcon from "@icons/close.svg";
import Badges from "../../../atoms/badges";

export default function LoanFilter(props) {
    const filterDispatcher = React.useContext(FilterDispatcherContext);
    const {show, checked} = props.items;

    function handleChange(event) {
        filterDispatcher({
            type: 'LOAN',
            payload: !checked
        });
    }

    return (
        <Loan selectBox={(!props.selectBox)} className={(show ? 'd-block' : 'd-none') + ' ' + (typeof props.className !== "undefined" ? props.className : '')}>
            {
                (typeof props.selectBox !== "undefined" && props.selectBox) ?
                    <CheckboxListGroup
                        onChange={(e) => handleChange(e)}
                        name="loan"
                        value={1}
                        checked={checked}
                        title="با وام باشد"
                    >
                        {
                            (checked) ?
                                <Badges color="primary" className="mr-8 close-icon d-inline-flex align-items-center justify-content-center" circle>
                                    <Icon width={7} height={7}><CloseIcon/></Icon>
                                </Badges>
                                : ''
                        }
                    </CheckboxListGroup>
                    :
                    <Switch label="فقط وام‌دار" id="has_loan" name="loan" labelClassName="w-100" checked={checked} onChange={(e) => handleChange(e)}/>
            }
        </Loan>
    )
}

const Loan = styled.div`
    padding: ${props => props.selectBox ? '12px 0' : ''};
    
    ${CheckboxGroupBox} {
        height: 35px;
        
        ${CheckboxGroupLabel} {
            height: 100%;
            flex-direction: row;
            padding: 0 16px;
            cursor: pointer;
            font-size: ${ConvertPixelToRem(14)};
            font-weight: 400;
            ${RadiusGenerate('50px')};
            border-color: ${props => props.theme.gray300};
            
            &:hover {
                border-color: ${props => props.theme.black};
                font-weight: 400;
            }
        }
        
        ${CheckboxInput}:checked+${CheckboxGroupLabel} {
            border: 1.5px solid ${props => props.theme.primary};
            background-color: ${props => props.theme.info};
            color: ${props => props.theme.black};
        }
    }
    
    .close-icon {
        margin-left: -8px;
    
        svg {
            g,path {
                stroke: #ffffff !important;
                stroke-width: 2.2px;
            }
        }
    }
`;